module.exports = __webpack_public_path__ + "img/oursolution4.8ca4a37c.png";